function replaceBlock() {
  const accordionBlock            = document.querySelector('.accordion__widget'),
    destinationAccordionBlock = document.querySelector('.product__info-wrapper.grid__item'),
    productWrapper = document.querySelector('.grid__item.product__media-wrapper');

  if (window.screen.width < 992) {
    if (accordionBlock && destinationAccordionBlock) {
      destinationAccordionBlock.append(accordionBlock);
    }
  } else {
    if (accordionBlock && productWrapper) {
      document.querySelector('.grid__item.product__media-wrapper').append(accordionBlock);
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {

  replaceBlock();

  window.addEventListener('resize', function (event) {
    replaceBlock();
  });

});


